// Users
export const FETCH_USERS = "FETCH_USERS";
export const GET_USER = "GET_USER";
export const GET_USER_REPOS = "GET_USER_REPOS";
export const GET_USER_ORGS = "GET_USER_ORGS";
export const CHANGE_GET_USER_LOADING_STATE = "CHANGE_GET_USER_LOADING_STATE";

// Repositories
export const SET_GET_REPO_DETAILS_ACTIVE = "SET_GET_REPO_DETAILS_ACTIVE";
export const SET_GET_REPO_DETAILS_INACTIVE = "SET_GET_REPO_DETAILS_INACTIVE";
export const GET_REPO_TAGS = "GET_REPO_TAGS";
export const GET_REPO_LANGUAGES = "GET_REPO_LANGUAGES";

//Organizations
export const SET_GET_ORG_DETAILS_ACTIVE = "SET_GET_ORG_DETAILS_ACTIVE";
export const SET_GET_ORG_DETAILS_INACTIVE = "SET_GET_ORG_DETAILS_INACTIVE";
export const GET_ORG_DETAILS = "GET_ORG_DETAILS";

// Toaster
export const SHOW_SUCCESS_TOASTER = "SHOW_SUCCESS_TOASTER";
export const SHOW_ERROR_TOASTER = "SHOW_ERROR_TOASTER";
export const HIDE_TOASTER = "HIDE_TOASTER";
